import { useFormikContext } from "formik";
import React from "react";

import { IOtherIncomes } from "../../../../config/interfaces";
import { FormField, NumericInputField } from "../../../fields";

const OIAnyTaxationReliefUS89AForm: React.FC = () => {
  const { values, handleBlur, errors, touched, setFieldValue } = useFormikContext<IOtherIncomes>();

  return (
    <section className="mb-5">
      <div className="section-title-wrap">
        <h5>Income claimed for taxation relief u/s 89A</h5>
      </div>
      <FormField label="Amount" sm={6}>
        <NumericInputField
          showLeftIcon={true}
          name="TaxationRelief89AAmount"
          value={values.TaxationRelief89AAmount}
          onBlur={handleBlur("TaxationRelief89AAmount")}
          onChange={(value) => setFieldValue("TaxationRelief89AAmount", value)}
          isInvalid={Boolean(errors.TaxationRelief89AAmount) && touched.TaxationRelief89AAmount}
          errorMsg={errors.TaxationRelief89AAmount}
          note="Note that you should submit Form 10EE to the Income Tax Department in order to claim this relief."
        />
      </FormField>
    </section>
  );
};

export default OIAnyTaxationReliefUS89AForm;
